/**
 * @generated SignedSource<<7c2040c8a9ca8da1f8f9c93178b5a67e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleReadingTimeContent$data = {
  readonly readingTime: number | null | undefined;
  readonly " $fragmentType": "articleReadingTimeContent";
};
export type articleReadingTimeContent$key = {
  readonly " $data"?: articleReadingTimeContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleReadingTimeContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleReadingTimeContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readingTime",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "a078e065c6d1335e79309fb8ef3bacdc";

export default node;
